import { render, staticRenderFns } from "./WiaaCertificationTile.vue?vue&type=template&id=2eeab111&scoped=true&"
import script from "./WiaaCertificationTile.vue?vue&type=script&lang=js&"
export * from "./WiaaCertificationTile.vue?vue&type=script&lang=js&"
import style0 from "./WiaaCertificationTile.vue?vue&type=style&index=0&id=2eeab111&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eeab111",
  null
  
)

export default component.exports